import { createAction } from '@reduxjs/toolkit';
export const setUserContext = createAction('user/setContext');
export const acceptTermsAndConditions = createAction('user/terms/acceptTermsAndConditions');
export const acceptTermsAndConditionsResolved = createAction('user/terms/acceptTermsAndConditions/resolved');
export const acceptTermsAndConditionsRejected = createAction('user/terms/acceptTermsAndConditions/rejected');
